"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMonthlyDataEmpty = exports.getOverTimeReportRoute = exports.getMonthlyChartColors = exports.buildPayeeRenderData = exports.chunkify = void 0;
const chunkify = (array, chunkSize) => Array(Math.ceil(array.length / chunkSize))
    .fill(null)
    .map((_, index) => index * chunkSize)
    .map((begin) => array.slice(begin, begin + chunkSize));
exports.chunkify = chunkify;
const buildPayeeRenderData = (payeeSpending, payeesPerPage) => {
    const spendingExcludingTransactions = payeeSpending.map((datum, index) => ({
        payee: datum.groupKey,
        amount: -datum.total,
        currency: datum.currency,
        index,
    }));
    spendingExcludingTransactions.length = 5;
    return (0, exports.chunkify)(spendingExcludingTransactions, payeesPerPage);
};
exports.buildPayeeRenderData = buildPayeeRenderData;
const getMonthlyChartColors = (isIncome, theme) => ({
    positiveDefault: theme.palette.reports.positiveColor,
    positiveDimmed: theme.palette.reports.positiveDimmed,
    negativeDefault: isIncome ? theme.palette.reports.negativeColor : theme.palette.error.main,
    negativeDimmed: theme.palette.reports.negativeDimmed,
    tooltipBullet: theme.palette.reports.positiveColor,
});
exports.getMonthlyChartColors = getMonthlyChartColors;
const getOverTimeReportRoute = (isIncome, index) => `/reports/${isIncome ? 'income' : 'spending'}/by-none/over-time${index != null ? `?selectMonth=${index}` : ''}`;
exports.getOverTimeReportRoute = getOverTimeReportRoute;
const isMonthlyDataEmpty = (monthlyData) => monthlyData.every((data) => data.txns.size === 0);
exports.isMonthlyDataEmpty = isMonthlyDataEmpty;
